import classNames from 'clsx';
import { camelCase } from 'lodash';
import React from 'react';
import type { Settings } from 'react-slick';

import { CrmArrow } from '@swf/components/CrmZone/Arrow';
import CrmZone from '@swf/components/CrmZone/CrmZone';
import type { WidgetFC } from '@swf/core/types/Widget';
import { getStyle } from '@swf/core/utils/casino';

import styles from './CrmWidget.scss';
import { crmWidgetModel, useCrmWidget } from './model';

const getCustomSettings = ({
  autoplay_speed: autoplaySpeed,
  ...settings
}: Settings & { autoplay_speed?: number }): Settings => ({
  ...settings,
  autoplaySpeed: autoplaySpeed as number,
  prevArrow: <CrmArrow />,
  nextArrow: <CrmArrow />
});

const CrmWidget: WidgetFC = () => {
  const { widgetConfig } = useCrmWidget();
  const {
    layout,
    zone_id: zoneId,
    component_type: componentType,
    sm_height: smHeight,
    md_height: mdHeight,
    lg_height: lgHeight,
    settings
  } = widgetConfig;

  if (!zoneId) {
    return null;
  }

  return (
    <div
      className={classNames(
        styles.container,
        styles[camelCase(`sm-h-${smHeight}`) as keyof typeof styles],
        styles[camelCase(`md-h-${mdHeight}`) as keyof typeof styles],
        styles[camelCase(`lg-h-${lgHeight}`) as keyof typeof styles]
      )}
      style={getStyle(layout)}
    >
      {zoneId && (
        <CrmZone
          componentType={componentType}
          settings={getCustomSettings(settings)}
          zoneId={zoneId}
        />
      )}
    </div>
  );
};

CrmWidget.model = crmWidgetModel;
export default CrmWidget;
